import {Component, Input, OnInit, ViewChild} from '@angular/core';

import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import { ALERT_MODAL } from "../../../constants/things.constants"


@Component({
  selector: 'app-restroom-alert',
  templateUrl: './restroom-alert.component.html',
  styleUrls: ['./restroom-alert.component.less']
})
export class RestroomAlertComponent {
  public type = ALERT_MODAL.type;
  public title = ALERT_MODAL.title;
  public contents = ALERT_MODAL.contents;
  button = [{}, {}, {}]

  constructor(public activeModal: NgbActiveModal) {
  }
  discard() {
    this.activeModal.close(false);
  }
  submit() {
    this.activeModal.close(true);
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/things/restroom-alert/restroom-alert.component.ts